import { Layout } from 'antd';
import { FC } from 'react';

import { useApiClient } from '@clh/ui';

import { Content, Header } from '../layout';
import Spinner from '../spinner/spinner';
import { DrilldownTable } from '../table';

import { Create } from './create';
import { Tabs } from './tabs';

export const Jurisdictions: FC = () => {
    const api = useApiClient();

    if (!api) {
        return <Spinner />;
    }

    return (
        <Layout>
            <Header>
                <h2>Jurisdictions</h2>
            </Header>
            <Content>
                <DrilldownTable
                    buttons={[<Create key="create" />]}
                    filters={{
                        search: 'search',
                        searchPlaceholder: 'Enter jurisdiction name',
                    }}
                    getRecords={(params) =>
                        api.jurisdictionControllerListJurisdictions(params)
                    }
                    cacheKey="jurisdictionControllerGetJurisdictions"
                    columns={['name', 'abbreviation']}
                >
                    <Tabs />
                </DrilldownTable>
            </Content>
        </Layout>
    );
};
